(function () {
    'use strict';

    angular.module('swif.ui')

    .directive('swifCsvToObjects', swifCsvToObjects);

    /**
    * @ngdoc directive
    * @name swif.ui:swifCsvToObjects
    * @module swif.ui
    * @restrict E
    * @description 
    * @usage 
    **/
    function swifCsvToObjects(swif) {
        var d = {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {
                fields: '=',
            }
        };
        d.templateUrl = 'partials/ui/csv_to_objects.html';
        d.link = function (scope, element, attr, ngModel) {
            scope.data = {};
            scope.data.separator = '\t';
            var get_objects = function (data) {
                var fields = scope.fields;
                var separator = scope.data.separator;
                if (!separator) {
                    separator = '\t';
                }
                var from_csv = [];
                if (_.isString(data)) {
                    var lines = data.split('\n');
                    _.forEach(lines, function (line) {
                        var splited = line.split(separator);
                        var o = {};
                        _.forEach(fields, function (field) {
                            o[field] = splited[fields.indexOf(field)];
                        });
                        from_csv.push(o);
                    });
                }
                return from_csv;
            };
            var updateModel = function (data) {
                ngModel.$setViewValue(get_objects(data));
            };
            scope.$watch('data.csv', function (newV) {
                updateModel(newV);
            });
            scope.$watch('data.separator', function (newV) {
                if (newV) {
                    updateModel(scope.data.csv);
                }
            });
        };
        return d;
    }

})();
